import {SplitText} from "gsap/all";
import {gsap} from "gsap";
export default class Woami {
    constructor() {
        this.animeWoami();
        if (window.matchMedia("(min-width: 1200px)").matches) {
            this.scrollAnimations();
        }
    }

    animeWoami = () => {

        const first = document.querySelector(".woami__title .first");
        const second = document.querySelector(".woami__title .second");
        const firstLine = first.querySelector(".line");
        const secondLine = second.querySelector(".line");
        const textIntro = document.querySelector('.woami__introduction .text');
        const split = new SplitText(textIntro, { type: "chars, words",  wordsClass: "word", charsClass: "char" });
        const mail = document.querySelector('.woami .mail__btn');
        const scrollLine = document.querySelector('.transitionLine--woami')
        const imgMask = document.querySelector(".woami__imageMask");
        const img = imgMask.querySelector('img');
        const circle = ('.woami__circle');

        const tlImage = gsap.timeline({
            delay: window.innerWidth >= 1200 ? .75 : 0
        });

        tlImage.to(imgMask, {duration:1, opacity:1, y:0})
            .to(circle, {duration: 1, opacity: 1, y: 0, x: 0}, '-=.5')
            .to(img, {duration:1.2, scale: .8}, '-=1.5')

        const tlText = gsap.timeline();

        tlText.to(second, {duration: .8, opacity: 1, x: '-5rem'})
            .to(secondLine, {duration: .8, width: 80}, '-=.2')
            .to(first, {duration: .8, opacity: 1, x: '3.5rem'}, "-=1s")
            .to(firstLine, {duration: .8, width: 80}, '-=.6')
            .to(textIntro, {opacity:1}, '')
            .to(split.chars, {
                opacity: 1,
                y: 0,
                duration: 1.2,
                stagger: 0.007
            } )
            .to(mail, {y: 0, duration: 1}, '-=1.2s')
    }


    scrollAnimations = () => {
        const image = document.querySelector('.woami__image');
        const description = document.querySelector('.woami__introduction');
        const title = document.querySelector('.woami__title')
        const section = document.querySelector('.woami');
        const lineWoami = document.querySelector('.transitionLine--woami')

        gsap.to(image, {
            x: 100,
            y: -200,
            ease: "none",
            scrollTrigger: {
                trigger: section,
                start: "200px 200px",
                end: "bottom top",
                scrub: 1,
            }
        });

        gsap.to(lineWoami, {
            y: -250,
            ease: "none",
            scrollTrigger: {
                trigger: section,
                start: "200px 200px",
                end: "bottom top",
                scrub: 1,
            }
        });

        gsap.to(title, {
            x: -100,
            y: -200,
            ease: "none",
            scrollTrigger: {
                trigger: section,
                start: "200px 200px",
                end: "bottom top",
                scrub: 1,
            }
        });

        gsap.to(description, {
            y: -100,
            opacity: 0,
            ease: "none",
            scrollTrigger: {
                trigger: section,
                start: "200px 200px",
                end: "bottom top",
                scrub: 1,
            }
        });
        gsap.to(description, {
            y: -200,
            opacity: 0,
            ease: "none",
            scrollTrigger: {
                trigger: section,
                start: "200px 200px",
                end: "bottom top",
                scrub: 1,
            }
        });
    }
}